import { render } from "./MrpDocuments.vue?vue&type=template&id=6a0fefbc&ts=true"
import script from "./MrpDocuments.vue?vue&type=script&lang=ts"
export * from "./MrpDocuments.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__